@use '~@frontrow/console/css/variables.scss';

.allMatchedStudent {
  font-weight: bold;
  color: #0fad00;
}

.nameTeacherMatchedStudent {
  font-weight: bold;
  color: #428bca;
}

.teachersPopover {
  color: #4bcfbe;
}

.confirmModalButtons {
  display: flex;
  justify-content: flex-end;
}
